export const ONBOARDING_MAX_ORDER_PROGRESS = 5;
export const ONBOARDING_QUERY_START_DATE = new Date('1 January 2022');
export const ONBOARDING_EXPERIMENT_START_DATE = new Date('12 December 2022');
export const ONBOARDING_STEPS_COUNT = 5;
